// extracted by mini-css-extract-plugin
export default {"CounterContainer":"index__CounterContainer__r7R6M","ClientsBlockedPortletStub":"index__ClientsBlockedPortletStub__d94RF","Counter":"index__Counter__vOgn9"};